import { Typography } from "@material-ui/core";

export const NotFoundPage = () => {
  return (
    <>
      <Typography variant="h4">404 - Page not found</Typography>
    </>
  )
};
